import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <circle cx="11.999" cy="12" r="1.99996" fill="#404545"></circle>
      <circle cx="5.99996" cy="12" r="1.99996" fill="#404545"></circle>
      <circle cx="18" cy="12" r="1.99996" fill="#404545"></circle>
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 24 24',
  boxSize: '24px',
}

export default IconComp
